const host = window.location.host

const config = {
  domain: '',
  zipsApi: {},
  chatApi: {},
  mapZoomLevels: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
}

if (host === 'localhost:8080') {
  config.domain = 'localhost:8080'
  config.zipsApi.domain = 'test-js.zmaps-api.com'
  config.zipsApi.authType = 'referer'
  config.zipsApi.key = '6qTvxJbR8c3Lkwmp2bxXQ8KDe13vfiV353LCwD1H'
  config.chatApi.websocket = 'wss://fiy7z8bo5h.execute-api.us-east-1.amazonaws.com'
  config.chatApi.domain = 'o2dzwsi7xh.execute-api.us-east-1.amazonaws.com'
} else if (host === 'dev-aws-aimaptool-web-ex-alb-331701711.ap-northeast-1.elb.amazonaws.com') {
  config.domain = 'dev-aws-aimaptool-web-ex-alb-331701711.ap-northeast-1.elb.amazonaws.com'
  config.shorturl = 'null'
  config.zipsApi.domain = 'test-js.zmaps-api.com'
  config.zipsApi.authType = 'referer'
  config.zipsApi.key = '6qTvxJbR8c3Lkwmp2bxXQ8KDe13vfiV353LCwD1H'
  config.chatApi.websocket = 'wss://fiy7z8bo5h.execute-api.us-east-1.amazonaws.com'
  config.chatApi.domain = 'o2dzwsi7xh.execute-api.us-east-1.amazonaws.com'
} else if (host === 'dev-sh.zmaps.jp') {
  config.domain = 'dev-sh.zmaps.jp'
  config.shorturl = 'dev-sh.zmaps.jp'
  config.zipsApi.domain = 'test-js.zmaps-api.com'
  config.zipsApi.authType = 'referer'
  config.zipsApi.key = '6qTvxJbR8c3Lkwmp2bxXQ8KDe13vfiV353LCwD1H'
  config.chatApi.websocket = 'wss://fiy7z8bo5h.execute-api.us-east-1.amazonaws.com'
  config.chatApi.domain = 'o2dzwsi7xh.execute-api.us-east-1.amazonaws.com'
} else if (host === 'aws-aimaptool-web-v-ex-alb-1804707845.ap-northeast-1.elb.amazonaws.com') {
  config.domain = 'aws-aimaptool-web-v-ex-alb-1804707845.ap-northeast-1.elb.amazonaws.com'
  config.shorturl = 'null'
  config.zipsApi.domain = 'test-js.zmaps-api.com'
  config.zipsApi.authType = 'referer'
  config.zipsApi.key = '6qTvxJbR8c3Lkwmp2bxXQ8KDe13vfiV353LCwD1H'
  config.chatApi.websocket = 'wss://hzauh2aou2.execute-api.us-east-1.amazonaws.com'
  config.chatApi.domain = '1o3c58aw34.execute-api.us-east-1.amazonaws.com'
} else if (host === 'sh.zmaps.jp') {
  config.domain = 'sh.zmaps.jp'
  config.shorturl = 'sh.zmaps.jp'
  config.zipsApi.domain = 'test-js.zmaps-api.com'
  config.zipsApi.authType = 'referer'
  config.zipsApi.key = '6qTvxJbR8c3Lkwmp2bxXQ8KDe13vfiV353LCwD1H'
  config.chatApi.websocket = 'wss://hzauh2aou2.execute-api.us-east-1.amazonaws.com'
  config.chatApi.domain = '1o3c58aw34.execute-api.us-east-1.amazonaws.com'
}

export default config
